import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex flex-col-reverse md:flex-row md:justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "rounded-full border px-2" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_9 = { class: "text-gray-700 font-medium" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" }, null, -1)
const _hoisted_11 = { class: "grid grid-col-1 md:grid-cols-4 gap-2" }
const _hoisted_12 = { class: "bg-gray-200 px-2 rounded-full w-fit" }
const _hoisted_13 = { class: "font-semibold text-sm" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "bg-gray-200 px-2 rounded-full w-fit" }
const _hoisted_18 = { class: "font-semibold text-sm" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "bg-gray-200 px-2 rounded-full w-fit" }
const _hoisted_23 = { class: "font-semibold text-sm" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "bg-gray-200 px-2 rounded-full w-fit" }
const _hoisted_28 = { class: "font-semibold text-sm" }
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_31 = { key: 0 }

import { ref, onBeforeMount, onMounted, watch } from "vue";
import PRating from "primevue/rating";
import { HHMMFromISO } from "@/assets/utils/date";

export default /*#__PURE__*/_defineComponent({
  __name: 'review',
  props: {
  reservation: {
    type: Object,
    default: () => ({}),
  },
  isShowDetails: {
    type: Boolean,
    default: () => false,
  },
},
  setup(__props) {

const props = __props;

// TODO: add pagination, filter by POS
const isShowDetails = ref(false);
const showDetails = () => {
  isShowDetails.value = true;
};

watch(
  () => props.isShowDetails,
  () => {
    isShowDetails.value = props.isShowDetails;
  }
);
onMounted(() => {
  //isShowDetails.value = props.isShowDetails;
  console.log("rendering", isShowDetails.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(`${__props.reservation.client?.firstName} ${__props.reservation.client?.lastName}`), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.reservation?.pos?.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(__props.reservation.rating.rating), 1),
          _hoisted_8
        ]),
        _createVNode(_unref(PRating), {
          modelValue: __props.reservation.rating.rating,
          cancel: false,
          readonly: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("publishedAt")) + " " + _toDisplayString(_unref(HHMMFromISO)(__props.reservation.rating?.at)), 1),
      _createTextVNode("  "),
      _hoisted_10,
      _createTextVNode(" " + _toDisplayString(__props.reservation.attendeesCount), 1)
    ]),
    _createElementVNode("p", null, _toDisplayString(__props.reservation.rating?.comment), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["underline text-blue-500 cursor-pointer", { invisible: isShowDetails.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetails()))
    }, _toDisplayString(_ctx.$t("showDetails")), 3),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("atmosphere")), 1),
          _createTextVNode("  "),
          _createElementVNode("span", _hoisted_14, _toDisplayString(__props.reservation.rating?.atmosphere?.rating), 1),
          _hoisted_15
        ]),
        (isShowDetails.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.reservation.rating?.atmosphere?.comment ??
            `(${_ctx.$t("commentWasntFilled")})`), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("food")), 1),
          _createTextVNode("  "),
          _createElementVNode("span", _hoisted_19, _toDisplayString(__props.reservation.rating?.food.rating), 1),
          _hoisted_20
        ]),
        (isShowDetails.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(__props.reservation.rating?.food?.comment ?? `(${_ctx.$t("commentWasntFilled")})`), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("qualityPriceRatio")), 1),
          _createTextVNode("  "),
          _createElementVNode("span", _hoisted_24, _toDisplayString(__props.reservation.rating?.qualityPriceRatio.rating), 1),
          _hoisted_25
        ]),
        (isShowDetails.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(__props.reservation.rating?.qualityPriceRatio?.comment ??
            `(${_ctx.$t("commentWasntFilled")})`), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("service")), 1),
          _createTextVNode("  "),
          _createElementVNode("span", _hoisted_29, _toDisplayString(__props.reservation.rating?.service.rating), 1),
          _hoisted_30
        ]),
        (isShowDetails.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(__props.reservation.rating?.service?.comment ??
            `(${_ctx.$t("commentWasntFilled")})`), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})